import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { AnimateLoading } from '../../../components/common/loading/AnimateLoading';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { usePatchSubsidyByIdMutation } from '../../../hooks/api/subsidy/mutations/usePatchSubsidyById.mutation';
import { useGetSubsidyByIdQuery } from '../../../hooks/api/subsidy/queries/useGetSubsidyById.query';
import { useLayout } from '../../../hooks/screen/useLayout';
import { SubsidyDetailView } from '../../../views/Subsidy/detailView/SubsidyDetailView';

export const SubsidyDetailPage = () => {
  const { subsidyId } = useParams();
  const [isViewCountIncremented, setIsViewCountIncremented] = useState<boolean>(false);

  const { data: subsidy, isLoading: isGetSubsidyQueryLoading } = useGetSubsidyByIdQuery({
    subsidyId: subsidyId!,
  });

  const { mutate: patchSubsidyById } = usePatchSubsidyByIdMutation();

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true, directlyPassedURL: pageInfo.subsidyListPage.path }} />,
    fixedHeaderHeight: 48,
    fixedFooterHeight: 92,
    style: {
      background: '#F0f0f0',
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (subsidy && subsidyId && !isViewCountIncremented) {
      patchSubsidyById({ subsidyId, reqBody: { views: subsidy.views + 1 } });
      setIsViewCountIncremented(true);
    }
  }, [subsidy, isViewCountIncremented, subsidyId, patchSubsidyById]);

  if (isGetSubsidyQueryLoading) return <AnimateLoading />;

  if (subsidy) {
    return (
      <>
        <Helmet>
          <title>{`${subsidy.title} - 지원금 - Pluva Market`}</title>
        </Helmet>
        <SubsidyDetailViewWrap>
          <SubsidyDetailView subsidy={subsidy} />
        </SubsidyDetailViewWrap>
      </>
    );
  }

  return null;
};

const SubsidyDetailViewWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
